import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BuscadorGeneralModule } from '../buscador-general/buscador-general.module';
import { NavbarComponentRouting } from './navbar.component-routing.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BuscadorGeneralModule,
    NavbarComponentRouting,
    MatTooltipModule
  ]
})
export class NavbarModule { }
